import {
    Component, Mixins, Emit,
} from 'vue-property-decorator';
import Classes from '@components/shared/mixins/classes';
import { YLoading, YIcon } from '@components/index';
import config from '@components/shared/config';
import Props from './props';

/**
 * @name Button
 */
@Component({
    components: {
        YLoading,
        YIcon,
    },
})
class YButton extends Mixins(Props, Classes) {
    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['color', 'size', 'icon', 'sharp', 'rounded', 'flat', 'raised', 'pill', 'outline', 'block'];

    /**
     * Create Common Props for the button.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> { // eslint-disable-line @typescript-eslint/no-explicit-any
        const commonProps: Record<string, any> = { // eslint-disable-line @typescript-eslint/no-explicit-any
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            commonProps[item] = this[item];
        });
        return commonProps;
    }

    /**
     * Create classes array for the button.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Button', this.commonProps, this.baseClass || config.prefix.button));

        if (this.text) {
            cls.push('is-text');
        }
        if (this.plain) {
            cls.push('is-plain');
        }
        if (this.fabIcon) {
            cls.push(config.propClasses.fab);
        }
        if (this.plain) {
            cls.push('is-plain');
        }

        if (this.loading || (this.loadingOn && this.$wait.is(this.loadingOn))) {
            cls.push('is-loading');
            cls.push('is-disabled');
        }

        if (this.disabled || (this.disabledOn && this.$wait.is(this.disabledOn))) {
            cls.push('is-disabled');
        }

        if (!this.noPadding) {
            cls.push('has-padding');
        }

        return cls;
    }

    /**
     * Return the status of the disable.
     * 
     * @returns {boolean}
     */
    get disabledStatus(): boolean {
        let status = false;
        if (this.disabled) {
            status = true;
        }
        if (this.disabledOn && this.$wait.is(this.disabledOn)) {
            status = true;
        }
        return status;
    }

    /**
     * Return the status of the loading.
     * 
     * @returns {boolean}
     */
    get loadingStatus(): boolean {
        let status = false;
        if (this.loading) {
            status = true;
        }
        if (this.loadingOn && this.$wait.is(this.loadingOn)) {
            status = true;
        }
        return status;
    }

    /**
     * Return the type of the loading from config.
     * 
     * @returns {string}
     */
    get loadingType(): string {
        return config.loading.type;
    }

    /**
     * Emit click event on callback.
     *
     * @param {object} e - Event of the click
     * @returns {*}
     */
    @Emit('click')
    click(e: Record<string, any>): any { // eslint-disable-line @typescript-eslint/no-explicit-any
        return e;
    }
}

export default YButton;
